import Api from "../api/api";

export default async ({ commentId, body }) => {
  const { data } = await Api.post(`comment/edit/${commentId}`, body);
  return data;
};
